module.exports = __webpack_public_path__ + "static/android-chrome-512x512-3776f6e3f0206bd680b9107f14d8cad6.png";